import { render } from "./InjuryUnit.vue?vue&type=template&id=149a44d9&scoped=true"
import script from "./InjuryUnit.vue?vue&type=script&lang=js"
export * from "./InjuryUnit.vue?vue&type=script&lang=js"

import "./InjuryUnit.vue?vue&type=style&index=0&id=149a44d9&lang=scss&scoped=true"
import "./InjuryUnit.vue?vue&type=style&index=1&id=149a44d9&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149a44d9"]])

export default __exports__